const { getCouncilReview } = require('apis/councils.api');
const { useMemo } = require('react');
const { useQuery } = require('react-query');

const useGetCouncilReview = (councilId, projectProposalId, conds = {}) => {
  const { data: councilReviewData, ...rest } = useQuery(
    ['council-review', councilId, projectProposalId],
    () => getCouncilReview(councilId, projectProposalId),
    {
      ...conds,
    }
  );

  const councilReview = useMemo(() => councilReviewData?.data ?? {}, [councilReviewData]);

  return { data: councilReview, ...rest };
};

export default useGetCouncilReview;
